export default "__VITE_ASSET__Br5kth3l__"